import { IDiagnosticWithRelations } from "../../filter/model";
import { IActivityHistoryItem } from "../model";
import { Spec } from "./spec";

export class DiagnosticCodeSpec extends Spec<IActivityHistoryItem> {
  private diagnosticCodes: string[];

  constructor(diagnostics: IDiagnosticWithRelations[]) {
    super();
    this.diagnosticCodes = this.extractAllCodes(diagnostics);
  }

  private extractAllCodes(diagnostics: IDiagnosticWithRelations[]): string[] {
    const codes = new Set<string>();

    for (const diagnostic of diagnostics) {
      // Afegir el codi principal (pare)
      if (diagnostic.codi) {
        codes.add(diagnostic.codi);
      }
      // Afegir codis de les evolucions
      if (diagnostic.evolucions && Array.isArray(diagnostic.evolucions)) {
        for (const evolucio of diagnostic.evolucions) {
          if (evolucio.codi) {
            codes.add(evolucio.codi);
          }
        }
      }
      // Afegir codis de les relacions
      if (diagnostic.relacions && Array.isArray(diagnostic.relacions)) {
        for (const relacio of diagnostic.relacions) {
          if (relacio.codi) {
            codes.add(relacio.codi);
          }
        }
      }
    }

    return Array.from(codes);
  }

  isSatisfiedBy(item: IActivityHistoryItem): boolean {
    if (!this.diagnosticCodes?.length) {
      return true; // No es filtra si no hi ha diagnòstics
    }

    const itemDiagnostics = item.diagnostics ?? [];

    return itemDiagnostics.some((d) => this.diagnosticCodes.includes(d.codi));
  }
}
